<template>
  <div>
    <Breadcrumb :style="{ margin: '20px 10px' }">
      <BreadcrumbItem>电子券管理</BreadcrumbItem>
      <BreadcrumbItem>补发券列表</BreadcrumbItem>
    </Breadcrumb>
    <div style="margin: 0 10px 10px 10px; display: flex; align-items: center;">
      <span style="margin-right: 8px; font-weight: bold;">自动审核：</span>
      <i-switch
          v-model="autoReviewEnabled"
          :loading="autoReviewLoading || autoReviewChanging"
          :before-change="handleAutoReviewChange"
          size="large"
      >
        <span slot="open">开启</span>
        <span slot="close">关闭</span>
      </i-switch>
      <span style="margin-left: 10px; color: #999; font-size: 12px;">
        {{ autoReviewEnabled ? '补发券申请将自动审核通过' : '补发券申请需人工审核' }}
    </span>
    </div>
    <loading :loading="loading" :error="error"></loading>
    <Form ref="selectForm" :model="selectForm" inline>
      <FormItem prop="phone">
        <Input v-model="selectForm.phone" placeholder="手机号" clearable ></Input>
      </FormItem>
      <FormItem prop="box_order_no">
        <Input
            v-model="selectForm.box_order_no"
            placeholder="三方订单号"
            clearable
        ></Input>
      </FormItem>
      <FormItem prop="voucher">
        <Input v-model="selectForm.voucher" placeholder="券码" clearable></Input>
      </FormItem>
      <FormItem prop="status">
        <Select
            v-model="selectForm.status"
            clearable
            placeholder="请选择状态"
            style="width: 150px; margin-right: 10px"
        >
          <Option value="0">待审核</Option>
          <Option value="1">审核成功</Option>
          <Option value="2">审核失败</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="goSelect()">查询</Button>
      </FormItem>
    </Form>
    <Table border stripe :columns="columns1" :data="coupons">
      <template slot-scope="{ row }" slot="spread">
        {{ row.spread_name }}（UID：{{ row.spread_uid }}）
      </template>
      <template slot-scope="{ row }" slot="status">
        <span>
          {{
            row.status == 0 ? '待审核' :
                row.status == 1 ? '审核成功' :
                    row.status == 2 ? '审核失败' : '未知状态'
          }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            v-if="row.status == 0"
            @click="review(row)"
        >审核</Button
        >
      </template>
    </Table>
    <Page
        style="margin: 10px; text-align: center"
        show-total
        @on-change="pageOnChange"
        :total="pages.total"
        :current="pages.current_page"
        :page-size="pages.per_page"
        show-elevator
        prev-text="上一页"
        next-text="下一页"
    />
    <Modal
        v-model="reviewModalVisible"
        title="补发券审核"
        :mask-closable="false"
        :closable="false"
    >
      <div v-if="currentReviewItem" style="margin-top: 10px; line-height: 2;">
        <p><strong>三方订单号：</strong>{{ currentReviewItem.box_order_no }}</p>
        <p><strong>手机号：</strong>{{ currentReviewItem.phone }}</p>
        <p><strong>名称：</strong>{{ currentReviewItem.alias }}</p>
        <p><strong>券码：</strong>{{ currentReviewItem.voucher }}</p>
      </div>
      <p style="margin-top: 14px; color: #999;">请选择审核结果：</p>

      <div slot="footer">
        <Button @click="cancelReview">取消</Button>
        <Button
            type="error"
            :loading="reviewLoading"
            @click="submitReview(1)"
        >驳回</Button>
        <Button
            type="primary"
            :loading="reviewLoading"
            @click="submitReview(0)"
        >通过</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import loading from "../loading.vue";
// import Dropdown from "../member/components/dropdown";
export default {
  name: "reissue_apply",
  components: { loading },
  data() {
    return {
      loading: false,
      error: null,
      coupons: [],
      pages: {
        total: 0,
        path: "",
        links: [],
        current_page: 1,
        per_page: 20
      },
      autoReviewEnabled: false,      // 开关当前状态：true=开启自动审核，false=关闭
      autoReviewLoading: false,      // 开关加载状态（获取配置时）
      autoReviewChanging: false,     // 开关切换中状态（提交更新时）
      selectForm: {
        phone:'',
        voucher:'',
        box_order_no: "",
        status:''
      },
      columns1: [
        { align: "center", title: "ID", key: "id", minWidth: 100 },
        { align: "center", title: "三方订单号", key: "box_order_no", minWidth: 150 },
        { align: "center", title: "名称", key: "alias", minWidth: 200 },
        { align: "center", title: "手机号", key: "phone", minWidth: 150 },
        { align: "center", title: "券码", key: "voucher", minWidth: 200 },
        { align: "center", title: "申请人", slot: "spread", minWidth: 200 },
        {
          align: "center",
          title: "申请时间",
          key: "created_at",
          minWidth: 250,
        },
        // { align: "center", title: "审核人", key: "review_spread_uid", minWidth: 200 },
        {
          align: "center",
          title: "审核时间",
          key: "review_time",
          minWidth: 250,
        },
        { align: "center", title: "状态", slot: "status", minWidth: 110 },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
        },
      ],
      reviewModalVisible: false,
      reviewLoading: false,
      currentReviewItem: null,
    }
  },
  created() {
    this.fetchAutoReviewConfig();
    if (this.$route.params.page) {
      let url = "coupons/couponReissueApplyList?page=" + this.$route.params.page;
      delete this.$route.params.page;
      this.selectForm = this.$route.params;
      this.fetchData(url, this.$route.params);
    } else {
      this.fetchData();
    }
  },
  methods: {
    fetchAutoReviewConfig() {
      console.log('11111')
      this.autoReviewLoading = true;
      this.axios.get('systemConfig')
          .then((res) => {
            const config = res.data.config;
            this.autoReviewEnabled = config.coupon_reissue_review === 1;
          })
          .catch((err) => {
            console.error('获取自动审核配置失败：', err);
            this.$Message.error('获取自动审核配置失败');
          })
          .finally(() => {
            this.autoReviewLoading = false;
          });
    },
    handleAutoReviewChange() {
      if (this.autoReviewChanging) return Promise.resolve(false);
      return new Promise((resolve) => {
        const targetStatus = !this.autoReviewEnabled;
        const actionText = targetStatus ? '开启' : '关闭';
        this.$Modal.confirm({
          title: '操作确认',
          content: `确定要${actionText}自动审核吗？`,
          onOk: () => {
            this.updateAutoReviewConfig(targetStatus);
            resolve(false); // 阻止 Switch 内部切换，由接口结果决定
          },
          onCancel: () => resolve(false), // 不切换
        });
      });
    },
    updateAutoReviewConfig(enabled) {
      this.autoReviewChanging = true;
      this.axios
          .post('updateSystemConfig', {
            coupon_reissue_review: enabled ? '1' : '0',
          })
          .then(() => {
            // 成功后才真正改变开关显示值
            this.autoReviewEnabled = enabled;
            this.$Message.success(enabled ? '自动审核已开启' : '自动审核已关闭');
          })
          .catch((err) => {
            console.error('更新自动审核配置失败：', err);
            this.$Message.error(
                (err && err.response && err.response.data && err.response.data.msg) ||
                (err && err.msg) ||
                '操作失败'
            );
            // 失败不改 this.autoReviewEnabled，开关保持原值
          })
          .finally(() => {
            this.autoReviewChanging = false;
          });
    },
    goSelect() {
      this.fetchData("coupons/couponReissueApplyList", this.selectForm);
    },
    pageOnChange: function (page) {
      this.pages.links.forEach((link) => {
        if (link.label == page) {
          this.fetchData(link.url);
          return;
        }
      });
      let url =
          this.pages.path.indexOf("?") > 0
              ? this.pages.path + "&page=" + page
              : this.pages.path + "?page=" + page;
      console.log("url=>", url);
      this.fetchData(url, this.selectForm);
    },
    fetchData(url = "coupons/couponReissueApplyList", params = {}) {
      let data = {};
      for (let key in params) {
        console.log("param[key],", params[key]);
        if (params[key] === undefined || params[key].length == 0) {
          delete params[key];
        }
      }
      data.params = params;
      this.axios.get(url, data).then((res) => {
        this.coupons = res.data.coupon_reissue_apply;
        this.pages = res.data.meta;
        console.log("this.pages=>", this.pages);
      });
    },
    review(row) {
      this.currentReviewItem = row;
      this.reviewModalVisible = true;
    },

    // 取消
    cancelReview() {
      this.reviewModalVisible = false;
      this.currentReviewItem = null;
    },

    submitReview(type) {
      if (!this.currentReviewItem) return;
      this.reviewLoading = true;
      this.axios
          .get(`coupons/couponReissueReview/${this.currentReviewItem.id}?type=${type}`)
          .then((res) => {
            console.log(res);
            this.reviewLoading = false;
            this.$Message.success(type === 0 ? "已通过" : "已驳回");
            this.currentReviewItem.status = type === 0 ? 1 : 2;
            this.reviewModalVisible = false;
            this.currentReviewItem = null;
          })
          .catch((err) => {
            this.reviewLoading = false;
            this.$Message.error(
                (err && err.response && err.response.data && err.response.data.msg) ||
                (err && err.msg) ||
                "操作失败"
            );
          });
    },
  }
}
</script>

<style scoped>

</style>